import { Theme } from '@mirai/ui';

export const getStyle = () => {
  const theme = Theme.get();

  const {
    accent,
    base,
    borderColor,
    borderRadius,
    content,
    error,
    font,
    fontBoldWeight,
    fontSizeAction,
    fontSizeHeadlinee1,
    fontSizeParagraph,
    fontWeight,
  } = theme;

  return {
    borderRadius: `${borderRadius}px`,
    colorBackground: base,
    colorBorder: borderColor,
    colorDanger: error,
    colorPrimary: accent,
    colorText: content,
    fontFamily: font,
    fontSize2Xs: `${fontSizeParagraph}px`,
    fontSize3Xs: `${fontSizeParagraph}px`,
    fontSizeBase: `${fontSizeParagraph}px`,
    fontSizeLg: `${fontSizeHeadlinee1}px`,
    fontSizeSm: `${fontSizeAction}px`,
    fontSizeXs: `${fontSizeParagraph}px`,
    fontWeightBold: fontBoldWeight,
    fontWeightNormal: `${fontWeight}px`,
  };
};
